import Button from "../../input/Button";
import { Minus, Plus } from "react-feather";

const ZoomControl = ({ onZoomIn, onZoomOut, zoom }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <Button
        Icon={Plus}
        style={{
          width: "40px",
          display: "flex",
          backgroundColor: "white",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          color: "black",
        }}
        onClick={onZoomIn}
        disabled={zoom === 22}
      />
      <Button
        Icon={Minus}
        style={{
          width: "40px",
          display: "flex",
          backgroundColor: "white",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          color: "black",
        }}
        onClick={onZoomOut}
        disabled={zoom === 0}
      />
    </div>
  );
};

export default ZoomControl;
